import { modal } from '@/share/components';
import { api } from '@/server';
import { apiHost } from '@/server/urls';
export const useExportZip = () => {
  const {
    runAsync: buildProjKpiMonitorZip
  } = fetchApi(api.kpi.projMonitor.buildZip, {
    showError: false
  });

  // exportProjKpiMonitorZip 下载项目绩效监控表电子表格压缩包
  const exportProjKpiMonitorZip = async projId => {
    if (!projId) {
      await modal.alert.error('提示', '绩效绩效表ID无效，不能打包下载监控表');
      return false;
    }
    const {
      error,
      url
    } = await buildProjKpiMonitorZip({
      projId
    });
    if (error) {
      modal.notification.error(`打开下载绩效监控表失败:${error}`, '打包下载').catch();
      return false;
    }
    if (!url) {
      modal.notification.error('下载地址为空，请联系管理员', '打包下载').catch();
      return false;
    }
    const linkUrl = url.startsWith('/') ? `${apiHost}${url}` : `${apiHost}/${url}`;
    try {
      window.open(linkUrl, '_blank');
      return true;
    } catch (e) {
      modal.notification.error('下载地址有误，请联系管理员', '打包下载').catch();
      return false;
    }
  };
  return {
    exportProjKpiMonitorZip
  };
};